import { useEffect } from "react";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { getStorageUsage } from "api/storageAPI";
import { calcStoragePercent } from "utils/functions";

const useStorageUsage = (accountId?: string, enabled = true) => {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { planStorageUpdated } = useAppSelector(
    (state) => state.subscriptionStomp
  );
  const resolvedAccountId = accountId ?? selectedAccount.accountId;

  const { data, refetch, isLoading } = useQuery(
    ["storageStatus", resolvedAccountId],
    () => getStorageUsage({ accountId: resolvedAccountId }),
    {
      enabled: enabled && !!resolvedAccountId,
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (resolvedAccountId === planStorageUpdated.targetAccountId) {
      refetch();
    }
  }, [planStorageUpdated, resolvedAccountId]);

  const totalStorage = data?.result.totalStorage ?? 0;
  const usedStorage = data?.result.usedStorage ?? 0;
  const percentage = calcStoragePercent(usedStorage, totalStorage);

  return { totalStorage, usedStorage, percentage, refetch, isLoading };
};

export default useStorageUsage;
